/**
 * StudioLibraryPage — V14.1 Sprint B (1d Bibliothèques)
 * =======================================================
 * Two-tab container :
 *   1. Matériauthèque — embeds the existing MaterialThequePage (zero rewrite)
 *   2. Configs prompt — lists saved prompt configs across projects, with
 *      a CTA to create a new "profil config" (placeholder for the moment).
 *
 * Why a wrapper page instead of two separate routes?
 *   The user mental-model groups these two as "Mes bibliothèques"
 *   (everything I can reuse across projects). Tabs keep that grouping
 *   visible without sacrificing the dedicated UX of each section.
 */
import { useState } from 'react';
import { Boxes, Sliders } from 'lucide-react';
import MaterialThequePage from '../MaterialThequePage';
import StudioPromptConfigsPanel from './StudioPromptConfigsPanel';

const TABS = [
  { id: 'materials', label: 'Matériauthèque',   icon: Boxes },
  { id: 'configs',   label: 'Configs prompts',  icon: Sliders },
];

const StudioLibraryPage = () => {
  const [active, setActive] = useState('materials');
  return (
    <div className="px-6 py-8 max-w-6xl mx-auto">
      <div className="mb-6">
        <p className="text-[11px] uppercase tracking-[0.20em] text-[#D9A05B] font-medium mb-2">
          Bibliothèques
        </p>
        <h1 className="font-[Chivo] font-light text-[32px] leading-tight tracking-tight text-white">
          Mes ressources réutilisables
        </h1>
      </div>

      {/* Tabs */}
      <div className="flex items-center gap-1 mb-6 border-b border-white/[0.06]">
        {TABS.map((t) => {
          const Icon = t.icon;
          const isActive = active === t.id;
          return (
            <button
              key={t.id}
              type="button"
              onClick={() => setActive(t.id)}
              data-testid={`lib-tab-${t.id}`}
              className={`relative inline-flex items-center gap-2 px-4 py-2.5 text-[12.5px] font-medium uppercase tracking-[0.14em] transition-colors ${
                isActive ? 'text-[#D9A05B]' : 'text-white/55 hover:text-white/85'
              }`}
            >
              <Icon className="w-3.5 h-3.5" />
              {t.label}
              {isActive && (
                <span aria-hidden className="absolute left-0 right-0 bottom-[-1px] h-[2px] bg-[#D9A05B]" />
              )}
            </button>
          );
        })}
      </div>

      {/* Tab content — Matériauthèque page rendered inline (no route change) */}
      {active === 'materials' && (
        <div className="rounded-xl overflow-hidden" style={{ background: '#141414', border: '1px solid rgba(255,255,255,0.06)' }}>
          <MaterialThequePage embeddedMode />
        </div>
      )}

      {active === 'configs' && <StudioPromptConfigsPanel />}
    </div>
  );
};

export default StudioLibraryPage;
